import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { currency } from '@utils';
import format from 'date-fns/format';
import subMonths from 'date-fns/subMonths';
import br from 'date-fns/locale/pt-BR';
import { FLink, Table, LoadingIndicator } from '@components';
import { getYear } from 'date-fns';
import { getExtratoContaRequest } from '../../../../store/modules/extratoContribuicao/actions';
import {
  ALTERAR_PC_ABSOLUTE_PATH,
  EMISSAO_BOLETO_VOLUNTARIO,
  SEGUNDA_VIA_BOLETO,
  TABELA_CONTRIBUICAO,
} from '../../../utils/paths';

function recuperaUltimos4Datas(mesAnoCorte) {
  const datas = [];
  let data = new Date(
    parseInt(mesAnoCorte[1], 10),
    parseInt(mesAnoCorte[0], 10) - 1,
    1
  );

  for (let i = 0; i < 4; i += 1) {
    datas.push(`${format(data, 'MM', { locale: br })}/${getYear(data)}`);
    data = subMonths(data, 1);
  }

  return datas.reverse();
}

function filtrarContasContribuicao(contas, mesAnoCorte) {
  const datas = recuperaUltimos4Datas(mesAnoCorte);

  return contas.filter(
    (value) => datas.includes(value.Data) && value.Item === 'Contribuição'
  );
}

export const ContribuicoesCard = () => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.user);
  const mesAnoCorte = users.corteExtrato;
  const extrato = useSelector((state) => state.extratoContribuicao);
  const {
    tabela_contribuicao: showTabelaContribuicao,
    percentual_contribuicao: showAlterarPC,
    aporte: showAporte,
    segunda_via_boleto: showSegundaBoleto,
  } = useSelector((state) => state.telasDisponiveis);

  const [contribuicoes, setContribuicoes] = useState([]);

  const getContribuicoes = useCallback(() => {
    const contaAdicional = filtrarContasContribuicao(
      extrato.ContaAdicional.Contas,
      mesAnoCorte
    );

    const contaIndividual = filtrarContasContribuicao(
      extrato.ContaIndividual.Contas,
      mesAnoCorte
    );

    const contaPatronal = filtrarContasContribuicao(
      extrato.ContaPatronal.Contas,
      mesAnoCorte
    );

    const datas = recuperaUltimos4Datas(mesAnoCorte);

    const tabelaFormatada = datas.map((data, index) => {
      const [month, year] = data.split('/');
      const dummyDay = 1;

      const date = new Date(+year, month - 1, dummyDay);

      const dadoMesContaAdicional = contaAdicional.filter((conta) =>
        format(date, 'MM', { locale: br }).toString() ===
        conta.Data.split('/')[0]
          ? conta.Valor
          : 0
      );

      const dadoMesContaPatronal = contaPatronal.filter((conta) =>
        format(date, 'MM', { locale: br }).toString() ===
        conta.Data.split('/')[0]
          ? conta.Valor
          : 0
      );

      const dadoMesContaIndividual = contaIndividual.filter((conta) =>
        format(date, 'MM', { locale: br }).toString() ===
        conta.Data.split('/')[0]
          ? conta.Valor
          : 0
      );

      return {
        id: index,
        mes: format(date, 'MMM', { locale: br }).toUpperCase(),
        voce:
          dadoMesContaIndividual.length === 0
            ? 0
            : dadoMesContaIndividual[0].Valor, // contaIndividual[index] ? contaIndividual[index].Valor : 0,
        empresa:
          dadoMesContaPatronal.length === 0 ? 0 : dadoMesContaPatronal[0].Valor, // contaPatronal[index] ? contaPatronal[index].Valor : 0,
        adicional:
          dadoMesContaAdicional.length === 0
            ? 0
            : dadoMesContaAdicional[0].Valor,
      };
    });

    setContribuicoes(tabelaFormatada.reverse());
  }, [
    extrato.ContaAdicional.Contas,
    extrato.ContaIndividual.Contas,
    extrato.ContaPatronal.Contas,
    mesAnoCorte,
  ]);

  useEffect(() => {
    if (extrato.done) getContribuicoes();
  }, [getContribuicoes, extrato.done]);

  useEffect(() => {
    if (!extrato.done && users.matricula !== undefined) {
      dispatch(getExtratoContaRequest());
    }
  }, [extrato.done, users.matricula, users.plano, dispatch, mesAnoCorte]);

  return !extrato.done ? (
    <LoadingIndicator />
  ) : (
    <div className="card h-100">
      <div className="card-body">
        <h1 className="ts-20 fw-bold mb-2">Contribuições</h1>
        <p className="ts-14 text-muted mb-3">
          Acompanhe as contribuições realizadas por você e pela patrocinadora
          nos últimos quatro meses.
        </p>
        {showTabelaContribuicao && (
          <Table columns={['', 'Você', 'Empresa', 'Adicional']}>
            {contribuicoes.map((cont) => (
              <tr key={cont.id}>
                <td className="fw-bold">{cont.mes}</td>
                <td>{currency(cont.voce)}</td>
                <td>{currency(cont.empresa)}</td>
                <td>{currency(cont.adicional)}</td>
              </tr>
            ))}
          </Table>
        )}
      </div>

      <div className="card-footer">
        {showAlterarPC && (
          <>
            <hr className="my-3" />
            <FLink to={ALTERAR_PC_ABSOLUTE_PATH} icon>
              Alterar percentual de contribuição
            </FLink>
            <hr className="my-3" />
            <FLink to={TABELA_CONTRIBUICAO} icon>
              Calculadora de contribuição
            </FLink>
          </>
        )}
        {showAporte && (
          <>
            <hr className="my-3" />
            <FLink to={EMISSAO_BOLETO_VOLUNTARIO} icon>
              Solicitação de contribuição voluntária
            </FLink>
          </>
        )}
        {showSegundaBoleto && (
          <>
            <hr className="my-3" />
            <FLink to={SEGUNDA_VIA_BOLETO} icon>
              Segunda via de boleto
            </FLink>
          </>
        )}
      </div>
    </div>
  );
};
